<template>
  <div class="row">

    <div class="col-12">

      <card>

        <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <h4 class="card-title">Forum Subscribers List</h4>
          <div class="d-flex justify-content-start">
            <div class="text-center pt-1 px-1">
              <a v-if="$store.getters['auth/checkAccess']('forums/export-subscribers')"
                 class="btn btn-info btn-wd export_excel" style="display:flex;"
                 @click="openModal('basic')"> Export to excel
                <span class="btn-label px-2">
                  <i class="nc-icon nc-cloud-download-93" style="font-size:20px;"></i>
                  </span>
              </a>

            </div>
          </div>
        </div>

        <div>
          <general-data-table
            ref="table"
            :key="tableKey"
            :method="'POST'"
            :api-url="'forums/subscribers/'+id">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :align="column.align"
                             :sortable="column.sortable"
                             :prop="column.value"
                             :label="column.label">

            </el-table-column>

            <el-table-column
              :min-width="120"
              :fixed="'right'"
              align="center"
              label="Actions">
              <template slot-scope="scope">
                <a v-if="$store.getters['auth/haveOneOfPermissions'](['forums/delete-subscriber'])"
                   v-tooltip.top-center="'Delete'"
                   class="btn-danger btn-simple btn-link"
                   @click="openDeleteModal(scope.row.id)"><i class="fa fa-times"></i></a>
              </template>
            </el-table-column>
          </general-data-table>
        </div>
      </card>
      <export-modal id="export-modal" title="Forum Subscribers" :url="'forums/export-subscribers/'+id"
                    :filters="exportFilters" :modals="modals"></export-modal>

      <delete-modal :visible="deleteModalVisibility"
                    :message="'Are you sure you want to delete this subscriber?'"
                    @close="closeDeleteModal()"
                    @confirm="confirmDeleteModal()">
      </delete-modal>
    </div>

  </div>
</template>
<script>
import {TableColumn} from 'element-ui'
import {DeleteModal, NewPagination as NLPagination, Switch as LSwitch} from '@/components'
import GeneralDataTable from "@/components/GeneralDataTable";
import ExportModal from '@/components/ExportModal/ExportModal.vue';

export default {
  components: {
    NLPagination,
    LSwitch,
    GeneralDataTable,
    [TableColumn.name]: TableColumn,
    ExportModal,
    DeleteModal,
  },

  data() {
    return {
      tableColumns: [
        {label: 'Name', value: 'full_name', minWidth: '200', align: 'center'},
        {label: 'Email', value: 'email', minWidth: '200', align: 'center'},
        {label: 'Phone', value: 'phone', minWidth: '200', align: 'center'},
        {label: 'Date', value: 'created_at', minWidth: '200', align: 'center'},
      ],
      fixedColumn: null,
      modals: {
        basic: false,
        centered: false,
        custom: false,
        confirm: false
      },
      exportFilters: [
        {
          key: 'forum_subscribers.created_at',
          type: 'date',
          frontType:'simple',
          strategy: 'gt',
          label: 'from',
          class: 'col-md-6 col-xs-12',
          value: null,
        },
        {
          key: 'forum_subscribers.created_at',
          type: 'date',
          frontType:'simple',
          strategy: 'lt',
          label: 'to',
          class: 'col-md-6 col-xs-12',
          value: null,
        },
        {
          key: 'forum_subscribers.email',
          type: 'text',
          frontType:'simple',
          label: 'Email',
          class: 'col-md-6 col-xs-12',
          value: null,
        },
      ],
      url : process.env.VUE_APP_SERVER_IMAGE_URL,
      id: 0,
      tableKey: 0,
      deleteModalVisibility: false,
      toDeleteId: undefined,
    }

  },
  mounted() {
    this.id = this.$route.params['id'];
    this.tableKey++;
  },
  methods: {
    openModal (name) {
      this.modals[name] = true
    },
    closeModal (name) {
      this.modals[name] = false
    },
    openDeleteModal(id) {
      this.deleteModalVisibility = true;
      this.toDeleteId = id;
    },

    closeDeleteModal() {
      this.deleteModalVisibility = false;
    },

    confirmDeleteModal() {

      let data = {
        'subscriber_id': this.toDeleteId,
        'forum_id': this.id,
      }
      this.axios.delete("forums/delete-subscriber", {headers: {}, data}).then((response) => {
        this.$notify({
          message: "Subscriber deleted successfully",
          timeout: 1000,
          type: 'success'
        });

        this.$refs.table.getData("updateData");

      }).catch((error) => {
        this.$notify({
          message: error.response.data.message,
          timeout: 2000,
          type: 'danger'
        })
      })

      this.closeDeleteModal();
      this.toDeleteId = undefined;
    },
  }
}
</script>

